import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ComplianceDemo } from '@/components/compliance-demo/ComplianceDemo';
import { AVAILABLE_COMPLIANCE_COMPANIES, COMPLIANCE_COMPANY_CONFIGS } from '@/constants/compliance-companies';

const ComplianceTraining: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company');

  if (!company || !AVAILABLE_COMPLIANCE_COMPANIES.includes(company as any)) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-gray-800 mb-2">Invalid Company</h1>
          <p className="text-gray-600">Please provide a valid company parameter.</p>
          <p className="text-sm text-gray-500 mt-4">Available: ms</p>
        </div>
      </div>
    );
  }

  const config = COMPLIANCE_COMPANY_CONFIGS[company as keyof typeof COMPLIANCE_COMPANY_CONFIGS];

  return <ComplianceDemo config={config} />;
};

export default ComplianceTraining;